/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { ccEnum } from '../../CCEnum';
import GoogleAnalytics from '../../GoogleAnalytics';
import { ccTouchEvent, ccTouchEventHelper } from '../../TouchEvent';
import ActionComponentBase from './ActionComponentBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/**
 * An extension of [[ActionComponentBase]] that responds to touches on the attached node.
 */
@cc._decorator.ccclass
export default class NodeTouchActionComponent extends ActionComponentBase
{
    protected action: (args?: any) => any = null;
    public set Action(value: (event: cc.Event.EventTouch, detail?: any) => any)
    {
        this.destroyListeners();
        this.action = value;
        this.configureListeners();
    }

    /** Which touch event to respond to. */
    @property({ type: ccEnum.TouchEvent, visible: true })
    private _touchEvent: ccTouchEvent = ccTouchEvent.TOUCH_END;

    /** Event target node. */
    @property(cc.Node)
    protected targetNode: cc.Node = null;
    public set TargetNode(value: cc.Node)
    {
        this.destroyListeners();
        this.targetNode = value;
        this.configureListeners();
    }

    /** @hidden */
    protected onLoad(): void
    {
        // Used by configureListeners, but be done before load.
        if (!this.targetNode) { this.targetNode = this.node; }

        super.onLoad();
    }

    private handler = (event: cc.Event.EventCustom) =>
    {
        event.bubbles = true;

        GoogleAnalytics.ClickEvent(this.node.name);
        this.action(event);
    }

    /** @hidden */
    protected configureListeners(): void
    {
        if (!this.action) { return; }

        this.targetNode.on(ccTouchEventHelper.GetEventName(this._touchEvent), this.handler.bind(this));
    }

    /** @hidden */
    protected destroyListeners(): void
    {
        if (!this.action) { return; }

        this.targetNode.off(ccTouchEventHelper.GetEventName(this._touchEvent), this.handler.bind(this));
    }

    protected isValidEvent(event: cc.Event.EventCustom): boolean
    {
        return event.target === this.targetNode && event.target !== cc.Canvas.instance.node;
    }
}
